module.exports = __webpack_public_path__ + "img/assistenza_bianca.9cb5b8c9.png";